module.exports = __webpack_public_path__ + "img/micromall_online02.ce17d429.png";